const LupaIcon = ({
    size,
    width = 36,
    height = 36,
    color = "#0468fb",
    ...rest
  }) => {

    const w = width  ?? size;
    const h = height ?? size;

    return (
    <svg viewBox="0 0 1080 1080" width={w} height={h} version="1.1" xmlns="http://www.w3.org/2000/svg" >
       
       <g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
       fill={color} stroke="none">
       <path d="M4305 9180 c-147 -19 -304 -49 -410 -79 -101 -29 -134 -40 -220 -76
       -16 -7 -55 -23 -85 -36 -54 -23 -67 -29 -205 -104 -93 -50 -248 -154 -311
       -207 -28 -24 -70 -59 -94 -78 -132 -105 -339 -337 -463 -517 -252 -370 -406
       -768 -479 -1238 -20 -129 -23 -188 -23 -425 0 -309 15 -447 80 -715 143 -589
       485 -1144 927 -1501 40 -32 75 -61 78 -65 13 -15 223 -151 285 -184 39 -21 90
       -49 114 -62 25 -14 79 -38 120 -54 42 -17 91 -37 109 -45 50 -23 268 -84 357
       -100 370 -65 630 -59 1005 25 96 21 257 75 345 116 17 7 64 29 105 48 143 65
       380 220 480 313 59 55 106 94 114 94 3 0 6 -26 6 -57 1 -73 21 -171 46 -217
       10 -19 53 -70 94 -113 60 -63 163 -174 275 -297 11 -13 195 -215 210 -232 187
       -207 218 -240 385 -423 52 -57 102 -112 110 -121 8 -9 58 -63 110 -120 52 -57
       103 -112 113 -124 75 -87 496 -545 552 -601 80 -79 121 -104 219 -130 60 -16
       75 -17 129 -6 85 18 164 62 236 131 70 69 96 114 117 208 14 61 14 75 0 140
       -27 128 -63 185 -228 364 -51 56 -101 110 -111 121 -10 12 -41 46 -70 77 -29
       31 -88 97 -132 145 -44 49 -107 119 -140 155 -33 36 -103 113 -155 170 -52 57
       -145 159 -205 225 -61 66 -221 242 -355 390 -135 149 -265 293 -291 320 -25
       28 -83 90 -127 139 -92 101 -131 136 -188 165 -45 23 -146 51 -186 51 -41 0
       -36 19 34 123 115 171 270 508 333 724 98 336 136 594 137 928 1 262 -21 446
       -83 705 -82 341 -235 683 -432 965 -62 90 -88 122 -177 230 -43 51 -243 249
       -290 287 -25 20 -65 53 -90 73 -107 89 -433 283 -520 310 -14 4 -47 18 -75 30
       -109 48 -285 99 -415 121 -47 8 -110 19 -140 25 -72 14 -436 20 -525 9z m486
       -690 c129 -19 225 -42 261 -61 10 -5 25 -9 33 -9 24 0 209 -78 277 -116 33
       -19 62 -34 64 -34 2 0 41 -25 86 -56 75 -51 106 -74 188 -139 47 -37 196 -191
       252 -260 252 -314 409 -685 464 -1099 18 -142 18 -460 -1 -591 -72 -510 -274
       -926 -610 -1260 -213 -211 -482 -374 -750 -455 -22 -7 -58 -18 -80 -25 -208
       -67 -656 -67 -885 -1 -25 8 -65 19 -90 27 -70 20 -228 87 -300 126 -74 41
       -244 151 -277 179 -12 10 -48 41 -80 69 -50 43 -190 189 -254 265 -12 14 -47
       63 -79 110 -355 527 -466 1164 -315 1815 33 141 120 371 193 505 35 67 172
       278 195 302 6 7 31 36 54 64 98 118 266 269 403 361 126 84 389 213 435 213 9
       0 23 4 33 9 33 18 121 40 204 51 45 7 101 16 123 20 80 16 318 11 456 -10z"/>
       </g>
       </svg>
    
    );
};



export default LupaIcon;